import * as React from "react";
const SvgArrow = props => <svg xmlns="http://www.w3.org/2000/svg" width={8} height={10} fill="none" viewBox="0 0 8 10" {...props}><path stroke="#369964" strokeLinecap="round" strokeLinejoin="round" d="M4 9.084V.917m0 0-3.5 3.5M4 .917l3.5 3.5" /></svg>;
export default SvgArrow;